import factory from '../transactions/position-transactions-factory';

export default factory({
  assetCategory: 'optionsDerivatives',
});
